import React from 'react';
import { PRIMARY } from '@/constants/colors';

interface LogoProps {
  width?: number;
  height?: number;
  color?: string;
}

const Logo: React.FC<LogoProps> = ({ width = 26, height = 20, color = PRIMARY }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 147 120"
    width={width}
    height={height}
    aria-label="Logo"
  >
    <g fill="none" stroke={color} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13.5 114.75V28.5" />
      <circle cx="13.875" cy="13.875" r="11.625" />
      <path d="M24.75 24.75L62.402 62.402" />
      <circle cx="73.875" cy="73.875" r="11.625" />
      <path d="M84.75 62.402L122.402 24.75" />
      <path d="M133.5 114.75V28.5" />
      <circle cx="133.875" cy="13.875" r="11.625" />
    </g>
  </svg>
);

export default Logo;
